import { cva } from '@/styled-system/css';

export const containerRecipe = cva({
  base: {},
  variants: {
    showDesktopViewBreakpoint: {
      md: {
        md: {
          marginLeft: '105px',
        },
      },
      xl: {
        xl: {
          marginLeft: '105px',
        },
      },
      xxl: {
        xxl: {
          marginLeft: '105px',
        },
      },
    },
  },
});

export const mobileContainerRecipe = cva({
  base: {
    display: 'block',
  },
  variants: {
    showDesktopViewBreakpoint: {
      md: {
        md: {
          display: 'none',
        },
      },
      xl: {
        xl: {
          display: 'none',
        },
      },
      xxl: {
        xxl: {
          display: 'none',
        },
      },
    },
  },
});

export const desktopContainerRecipe = cva({
  base: {
    display: 'block',
  },
  variants: {
    showDesktopViewBreakpoint: {
      md: {
        mdDown: {
          display: 'none',
        },
      },
      xl: {
        xlDown: {
          display: 'none',
        },
      },
      xxl: {
        xxlDown: {
          display: 'none',
        },
      },
    },
  },
});

export const wizardTipCardRecipe = cva({
  base: {
    padding: '{spacing.600} {spacing.400}',
    borderRadius: '{radii.300}',
  },
  variants: {
    isPremium: {
      true: {
        width: { base: '100%', xl: '294px' },
        borderTop: '3px solid {colors.border.accent.brand.hero}',
      },
      false: {
        width: { base: '100%', md: '294px' },
      },
    },
  },
});
